import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

export default function NavbarAside({ userData, isOpen, onClose }) {
  const [collapsed, setCollapsed] = useState(false);
  const [reportsOpen, setReportsOpen] = useState(false);
  const isAdmin = userData?.isAdmin === true;

  const toggleSidebar = () => setCollapsed(!collapsed);
  const toggleReports = () => setReportsOpen(!reportsOpen);

  // Close sidebar on mobile when a link is clicked
  const handleNavClick = () => {
    if (window.innerWidth <= 768) {
      onClose?.();
    }
  };

  // Close sidebar when window is resized to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        onClose?.();
        setCollapsed(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [onClose]);

  return (
    <>
      {/* Sidebar Overlay for Mobile */}
      {isOpen && (
        <div className="sidebar-overlay active" onClick={onClose}></div>
      )}

      {/* Sidebar */}
      <aside
        className={`sidebar ${collapsed ? "collapsed" : ""} ${
          isOpen ? "open" : ""
        }`}
      >
        <div className="sidebar-header">
          <div className="logo">
            <img src="/assets/images/logo.png" alt="Logo" />
          </div>
          <button
            id="sidebarToggle"
            className="sidebar-toggle"
            onClick={toggleSidebar}
            aria-label="Toggle Sidebar"
          >
            <i
              className={`fas ${
                collapsed ? "fa-angle-right" : "fa-angle-left"
              }`}
            ></i>
          </button>
        </div>

        <nav className="main-nav">
          <ul>
            <li>
              <NavLink
                to="/dashboard"
                end
                title="Dashboard"
                onClick={handleNavClick}
              >
                <i className="fas fa-home"></i>
                {!collapsed && <span>Dashboard</span>}
              </NavLink>
            </li>
            <li>
              <NavLink to="/orders" title="Orders" onClick={handleNavClick}>
                <i className="fas fa-box"></i>
                {!collapsed && <span>Orders</span>}
              </NavLink>
            </li>

            {isAdmin && (
              <li className={`has-submenu ${reportsOpen ? "open" : ""}`}>
                <div className="nav-item" onClick={toggleReports}>
                  <NavLink to="/reports" title="Reports">
                    <i className="fas fa-chart-line"></i>
                    {!collapsed && (
                      <>
                        <span>Reports</span>
                        <i
                          className={`fas fa-chevron-${
                            reportsOpen ? "up" : "down"
                          } dropdown-icon`}
                        ></i>
                      </>
                    )}
                  </NavLink>
                </div>
                {!collapsed && (
                  <ul className={`sub-menu ${reportsOpen ? "show" : ""}`}>
                    <li>
                      <NavLink
                        to="/reports/profit-loss"
                        title="Profit & Loss"
                        onClick={handleNavClick}
                      >
                        <i className="fas fa-file-invoice-dollar"></i>
                        <span>Profit & Loss</span>
                      </NavLink>
                    </li>
                  </ul>
                )}
              </li>
            )}
            {isAdmin && (
              <li>
                <NavLink
                  to="/addUsers"
                  title="Add Users"
                  onClick={handleNavClick}
                >
                  <i className="fas fa-user"></i>
                  {!collapsed && <span>Add Users</span>}
                </NavLink>
              </li>
            )}
            {isAdmin && (
              <li>
                <NavLink to="/menu" title="Menu" onClick={handleNavClick}>
                  <i className="fas fa-utensils"></i>
                  {!collapsed && <span>Menu</span>}
                </NavLink>
              </li>
            )}
            {isAdmin && (
              <li>
                <NavLink
                  to="/printerconfig"
                  title="Printer Configuration"
                  onClick={handleNavClick}
                >
                  <i className="fas fa-print"></i>
                  {!collapsed && <span>Printer</span>}
                </NavLink>
              </li>
            )}
          </ul>
        </nav>
      </aside>
    </>
  );
}
